export var TimeRegistrationEntity;
(function (TimeRegistrationEntity) {
    TimeRegistrationEntity["Task"] = "Task";
    TimeRegistrationEntity["Project"] = "Project";
    TimeRegistrationEntity["IdleTime"] = "IdleTime";
})(TimeRegistrationEntity || (TimeRegistrationEntity = {}));
